// ----------------------------------------------------------------------------
// Template: How-To
// ----------------------------------------------------------------------------
// How-To Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-header/page-header';

// Styles
import './_how-to.scss';

class ShowMoreButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.toggleContent);
    }

    toggleContent(e) {
        e.preventDefault();
        const howToWarnings = document.querySelector('.how-to-warnings');
        if (howToWarnings) {
            howToWarnings.classList.toggle('expanded');
        }
    }
}

customElements.define('show-more-button', ShowMoreButton);
